import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "feedback"]
  static values = {
    expected: String,
    successMessage: { type: String, default: "That matches. You can delete now." }
  }

  connect() {
    this.validate()
  }

  validate() {
    const value = this.inputTarget.value
    const matches = value === this.expectedValue

    this.submitTarget.disabled = !matches
    this.feedbackTarget.classList.toggle("matches", matches)

    if (value.length === 0) {
      this.feedbackTarget.textContent = "Type the exact name shown above to continue."
    } else {
      this.feedbackTarget.textContent = matches ? this.successMessageValue : "That does not match yet."
    }
  }
}
